export default "__VITE_ASSET__DxbcWUXc__"